module.exports = __webpack_public_path__ + "static/img/weather_018.0a01219f.svg";